import { render, staticRenderFns } from "./GiftVendorModal.Style#Drawer.vue?vue&type=template&id=17b334fc&scoped=true&"
import script from "./GiftVendorModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./GiftVendorModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./GiftVendorModal.Style#Drawer.vue?vue&type=style&index=0&id=17b334fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b334fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b334fc')) {
      api.createRecord('17b334fc', component.options)
    } else {
      api.reload('17b334fc', component.options)
    }
    module.hot.accept("./GiftVendorModal.Style#Drawer.vue?vue&type=template&id=17b334fc&scoped=true&", function () {
      api.rerender('17b334fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/GiftVendorModal.Style#Drawer.vue"
export default component.exports